import { ApiEndpoints } from '../api/endpoints';
import TableIds from '../constants/tableIds';
import { getPagedRequest } from '../helpers/table';
import store from '../store';
import apiService from './apiService';
class NotificationsService {
    constructor() {
        this.notificationsTableStore = store.table[TableIds.NOTIFICATIONS];
        this.getNotifications = () => {
            this.notificationsTableStore.startFetching();
            const sort = this.notificationsTableStore.getSort();
            const pagination = this.notificationsTableStore.getPagination();
            const searchValue = this.notificationsTableStore.getSearchValue();
            const filteredRequest = getPagedRequest(sort, pagination, searchValue);
            apiService.post(ApiEndpoints.notifications.get, filteredRequest)
                .then((result) => {
                this.notificationsTableStore.fetchSuccess(result.data.items, result.data.totalRecords);
            })
                .catch(() => {
                this.notificationsTableStore.fetchFail();
            });
        };
        this.toggleRead = (notificationId) => {
            this.notificationsTableStore.startFetching();
            apiService.post(`${ApiEndpoints.notifications.toggleRead}/${notificationId}`)
                .then(() => this.getNotifications())
                .catch(() => this.notificationsTableStore.fetchFail());
        };
    }
}
export default new NotificationsService();
